module.exports = __webpack_public_path__ + "static/media/fish-face-test3-01-01.daf0af44.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/fish-face-test3-01-01.png
// module id = 248
// module chunks = 1